import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import axios from 'axios'

window.Pusher = Pusher
window.axios = axios

// Инициализация Laravel Echo для работы с Reverb
const isHttps = typeof window !== 'undefined' && window.location.protocol === 'https:'
const defaultPort = isHttps ? 443 : 8085
const host = process.env.VUE_APP_REVERB_HOST || (typeof window !== 'undefined' ? window.location.hostname : 'localhost')

window.Echo = new Echo({
  broadcaster: 'reverb',
  key: process.env.VUE_APP_REVERB_APP_KEY || 'app_key_local_123',
  wsHost: host,
  wsPort: Number(process.env.VUE_APP_REVERB_PORT || defaultPort),
  wssPort: Number(process.env.VUE_APP_REVERB_PORT || defaultPort),
  forceTLS: isHttps,
  encrypted: isHttps,
  disableStats: true,
  enabledTransports: isHttps ? ['ws', 'wss'] : ['ws'],
  authorizer: (channel) => {
    return {
      authorize: (socketId, callback) => {
        axios.post('/api/broadcasting/auth', {
          socket_id: socketId,
          channel_name: channel.name
        })
        .then(response => {
          callback(null, response.data)
        })
        .catch(error => {
          callback(error)
        })
      }
    }
  }
})

// Автоматически передаем X-Socket-ID во все HTTP-запросы axios,
// чтобы broadcast(...)->toOthers() на бэкенде корректно исключал отправителя
axios.interceptors.request.use((config) => {
  try {
    if (window.Echo && typeof window.Echo.socketId === 'function') {
      const socketId = window.Echo.socketId()
      if (socketId) {
        config.headers['X-Socket-ID'] = socketId
      }
    }
  } catch (e) {
    // игнорируем ошибки получения socketId
  }
  return config
})

export default window.Echo
